import App from './App';
import CssBaseline from '@material-ui/core/CssBaseline';
import ErrorMsg from 'components/ErrorBoundaryUI';
import LogRocket from 'logrocket';
import React from 'react';
import ReactDOM from 'react-dom';
import client from './graphql/apollo-client';
import theme from './theme';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider, FirebaseAppProvider } from 'reactfire';
import { ErrorBoundary } from 'react-error-boundary';
import { ThemeProvider } from '@mui/material';
import { auth, firebaseConfig } from './utils/firebase';
import './index.css';
import './utils/console';

function onErrorHandler(error: Error, info: { componentStack: string }) {
  try {
    LogRocket.captureException(error, {
      extra: {
        errorMessage: error.message,
        componentStack: info.componentStack,
      },
    });
  } catch (error) {
    console.log('Error while logging to LogRocket from error boundary', error);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ErrorMsg />} onError={onErrorHandler}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FirebaseAppProvider firebaseConfig={firebaseConfig}>
          <AuthProvider sdk={auth}>
            <ApolloProvider client={client}>
              <App />
            </ApolloProvider>
          </AuthProvider>
        </FirebaseAppProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.querySelector('#root')
);
